module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_yq_aidmx.2477b585.png";